import { FC, useCallback } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { composeValidateActionCreator } from 'actions/feedComposeActions'
import { ComposeId } from 'interfaces/feed'
import { AnalyticsClick } from 'components/features/pfm/AnalyticsClick/AnalyticsClick'
import Button from 'components/features/pfm/Button/Button'
import styles from 'components/features/socialFeed/ComposeActions/ComposeActions.styl'

type SubmitButtonProps = {
  composeId: ComposeId
  text: string
  isDisabled: boolean
}

export const SubmitButton: FC<SubmitButtonProps> = ({ isDisabled, text, composeId }) => {
  const dispatch = useStoreDispatch()
  const handleSubmit = useCallback(() => {

    dispatch(composeValidateActionCreator.request({
      composeId,
    }))
  }, [composeId, dispatch])
  return (
    <AnalyticsClick
      className={ styles.postButton }
      category='module-feed_compose'
      action='click-cta'
      label={ text }
    >
      <Button
        theme='blue'
        shadow='blue'
        fullHeight
        fullWidth
        disabled={ isDisabled }
        onClick={ handleSubmit }
      >
        { text }
      </Button>
    </AnalyticsClick>

  )
}
